/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { Icon } from 'learning-panel-components';
import { translate } from 'translations';
import PieChart from './progressPie/pieChart';
import AssignedContentFullExpandedContainer from './assignedContentFullExpandedContainer';
import styles from './assignedContent.module.scss';
import AssignedContentCollapsed from './assignedContentCollapsed';

const AssignedContent: FC<AssignedContentProps> = (props: AssignedContentProps) => {
    const { courseRate, lessonsRate, assessmentsRate } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpandedFull, setIsExpandedFull] = useState(false);

    const getTotalRate = () => {
        return courseRate?.percent + lessonsRate?.percent + assessmentsRate?.percent;
    };

    return isExpanded ? (
        <div data-testid="assigned-content" className={styles['assigned-content-wrapper']}>
            <div className={styles.top}>
                <div className={styles.title}>{translate('AssignedContent')}</div>
                <div className={styles['icons-wrapper']}>
                    <div
                        onClick={() => {
                            setIsExpandedFull(true);
                            setIsExpanded(false);
                        }}
                    >
                        <Icon data-testid="arrow-icon" name={'upDownExpand'} className={styles.icon} />
                    </div>
                    <div
                        onClick={() => {
                            setIsExpanded(false);
                            setIsExpandedFull(false);
                        }}
                    >
                        <Icon data-testid="arrow-icon" name={'close'} className={styles.icon} />
                    </div>
                </div>
            </div>
            <hr />
            <div className={styles['primary-course-wrapper']}>
                <div className={styles['primary-course']}>
                    <div className={styles.text}>{translate('primaryCourse')}</div>
                    <div className={styles.percent}>{`${Math.trunc(courseRate.percent)}%`}</div>
                </div>

                <div className={styles.divsion}>{`(${courseRate.completionLesson}/${
                    courseRate.totalLessons
                } ${translate('lessons')})`}</div>

                <div className={styles['primary-course-content-wrapper']}>
                    <div className={styles['primary-course-content']}>
                        {Array(courseRate.totalLessons)
                            .fill('')
                            .map((_, i) => (
                                <div
                                    key={i}
                                    className={
                                        styles[i < courseRate.completionLesson ? 'done-lesson' : 'not-done-lesson']
                                    }
                                ></div>
                            ))}
                    </div>
                </div>
            </div>
            <hr />
            <div className={styles['pies-wrapper']}>
                <div className={styles['pie-details']}>
                    {lessonsRate.totalLessons > 0 ? (
                        <PieChart percentage={lessonsRate.percent} />
                    ) : (
                        <div className={styles['empty-text']}>{translate('noAssignedLessonsMessage')}</div>
                    )}
                    <div className={styles['content-titles']}>
                        <div className={styles['title-text']}>{translate('AdditionalLessons')}</div>
                        <div className={styles['title-numbers']}>
                            {lessonsRate.totalLessons > 0
                                ? `(${lessonsRate.completionLesson}/${lessonsRate.totalLessons})`
                                : '(0)'}
                        </div>
                    </div>
                </div>
                <div className={styles['pie-details']}>
                    {assessmentsRate.totalAssessments > 0 ? (
                        <PieChart percentage={assessmentsRate.percent} />
                    ) : (
                        <div className={styles['empty-text']}>{translate('noAssignedLessonsMessage')}</div>
                    )}
                    <div className={styles['content-titles']}>
                        <div className={styles['title-text']}>{translate('Assessments')}</div>
                        <div className={styles['title-numbers']}>
                            {assessmentsRate.totalAssessments > 0
                                ? `(${assessmentsRate.completionAssessments}/${assessmentsRate.totalAssessments})`
                                : '(0)'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : isExpandedFull ? (
        <AssignedContentFullExpandedContainer onUnExpand={setIsExpanded} onClose={setIsExpandedFull} />
    ) : (
        <AssignedContentCollapsed isLoading={false} percent={Math.trunc(getTotalRate() / 3)} onExpand={setIsExpanded} />
    );
};

interface AssignedContentProps {
    courseRate: {
        completionLesson: number;
        totalLessons: number;
        percent: number;
    };
    lessonsRate: {
        completionLesson: number;
        totalLessons: number;
        percent: number;
    };
    assessmentsRate: {
        completionAssessments: number;
        totalAssessments: number;
        percent: number;
    };
}

export default AssignedContent;
